'use strict';

var ServiceDateRangeLevelChartAggregationFactory = function ServiceDateRangeLevelChartAggregationFactory(DataAggregationFactory, ExtractMetricKeysService, momentService) {
  function ServiceDateRangeLevelChartAggregation() {
    DataAggregationFactory.call(this, 'service', 'date-range-level-chart');
  }
  ServiceDateRangeLevelChartAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  ServiceDateRangeLevelChartAggregation.constructor = ServiceDateRangeLevelChartAggregation;
  ServiceDateRangeLevelChartAggregation.prototype.aggregate = function (data, metrics) {
    var aggregationFunction = this.getAggregationFunction(metrics);
    var keys, keysLength, metricKeys;
    var aggregatedDepartureDates = {};
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      if (Array.isArray(aggregatedDepartureDates[data[index].departureDate])) {
        aggregatedDepartureDates[data[index].departureDate].push(data[index]);
      } else {
        aggregatedDepartureDates[data[index].departureDate] = [data[index]];
      }
    }
    keys = Object.keys(aggregatedDepartureDates);
    if (keys.length > 0) {
      metricKeys = ExtractMetricKeysService.extract(aggregatedDepartureDates[keys[0]][0]);
    }
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      var reducedEntry = {};
      var date = keys[index];
      reducedEntry.departureDateMoment = momentService.of(date, momentService.FIELD.DEPARTURE_DATE, momentService.FORMAT.DATE_ISO);
      reducedEntry.created = momentService.of(date, momentService.FIELD.CREATED_DATE, momentService.FORMAT.DATE_ISO);
      aggregationFunction(aggregatedDepartureDates[date], metricKeys, reducedEntry);
      aggregatedDepartureDates[date] = reducedEntry;
    }
    return this.sortAggregationResults(aggregatedDepartureDates);
  };
  return ServiceDateRangeLevelChartAggregation;
};
ServiceDateRangeLevelChartAggregationFactory.$inject = ['DataAggregationFactory', 'ExtractMetricKeysService', 'MomentService'];
module.exports = ServiceDateRangeLevelChartAggregationFactory;